import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import CustomImageTable from '../../../../../components/CustomImageTable';
import CustomChip from '../../../../../components/CustomChip';
import { userType } from '../../../../../enums/userTypeEnum';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import { DetailsIconsOptions, IconAvatarTable } from '../../../../../components/buttons/IconButtons';
import routes from '../../../../../Routes/routes';
import TableFunction from '../../../../../components/table/TableFunction';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import { colors } from '../../../../../enums/colors';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import { TABLES } from '../../../../../Apis/Tables';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../../enums/statusEnum";
import {TABS_TRAFFIC, TRAFFIC_SUB_VIEW_MODEL} from "../../Model/Model";
import CustomTooltip from '../../../../../components/CustomTooltip';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const UsersTableApp = ({ searchElement, handleOpenModal, setBodyForExport }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [searchResults, setSearchResults] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [tableId, setTableId] = useState('tbl_ut_users');
    const [searchId, setSearchId] = useState('txt_ut_search_users');
    const [option, setOption] = useState(TABLES.FINE_USER);

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes='first_head'>
                {t('name')}
            </CustomTh>,
            <CustomTh tableId={tableId}>{t('profile')}</CustomTh>,
        ];
    };
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };
        let aux = searchResults?.content;
        let body = aux.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} classes={'first-column'}>
                        <CustomImageTable image={IconAvatarTable} containerClass={'d-flex align-items-center'}>
                            <div className={'ml-1'}>
                                  <div className={'ml-1'}>
                                   <CustomTooltip
                                    text={item?.fullName || EMPTY_VALUES.DEFAULT}
                                    classes={`fs-14px font-color-general-950  text-ellipsis`}
                                    showIfTruncated={true}
                                />
                                </div>
                                { !item?.statusId ?//Normal
                                    <CustomChip
                                        background={colors.secondary100}
                                        fontColor={colors.secondary700}
                                        borderColor={colors.secondary150}
                                        legend={t("normal")}
                                        variant={'large'}
                                    />
                                    :
                                    item?.statusId === STATUS_MODEL.ISSUED ? //Fined
                                        <CustomChip
                                            background={colors.errorCode100}
                                            fontColor={colors.errorCode700}
                                            borderColor={colors.errorCode150}
                                            legend={t("fined")}
                                            variant={'large'}
                                        />
                                    :
                                    <CustomChip //Account locked
                                        background={statusColor[item?.statusId]}
                                        fontColor={statusFontColor[item?.statusId]}
                                        borderColor={statusBorderColor[item?.statusId]}
                                        legend={t(status[item?.statusId])}
                                        variant={'large'}
                                    />
                                }
                            </div>
                        </CustomImageTable>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            legend={t(userType[item?.userTypeId])}
                            variant={'compact'}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: aux,
        };
    };

    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions />}
                        click={() => {
                            goUrl(`${routes.traffic.details}${item.id}`);
                        }}
                    />
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Navigate to a specific URL while preserving tab and subview state.
     */
    const goUrl = (url) =>{
        navigate(url, {
            state: { currentTab: TABS_TRAFFIC.TRAFFIC_FINES.INDEX, currentSubView: TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS },
        });
    }
    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: option });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    }


    /**
     * Pagination for list view, and other
     */
    const {
        t,
        thead,
        tbody,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        page,
        rowsPerPage,
    } = TableFunction({
        data: searchResults,
        labelRowsPerPage: 'users_per_page',
        getTbody,
        getThead,
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        navigate,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        page,
        rowsPerPage,
        search,
        setSearch,
        setSimpleSearch,
        searchResults,
        setSearchResults,
        handleOpenModal,
        option,
        simpleSearch,
    };
};

export default UsersTableApp;
